import {
    Box,
    Checkbox,
    Grid,
    ListItemText,
    Modal, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow,
    Typography,
    ToggleButtonGroup,
    ToggleButton
} from "@mui/material";
import { forwardRef, useEffect, useState } from 'react';
import { makeStyles } from "@mui/styles";
import React from "react";
import OutlinedInput from '@mui/material/OutlinedInput';
import CheckIcon from '@mui/icons-material/Check';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import sort from "../../../images/sort-arrow.png"
import * as echarts from "echarts";
import CaseGroup from "../../../helper/CaseGroup";
import { getDashboardData, getGroupData, groupsList, LensActions, updateCaseGroups, reloadDashboardData } from "../../../actions";
import { useTranslation } from 'react-i18next';
import timeLogo from "../../../images/Group 196.svg"
import _ from "lodash";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { groupBy } from "lodash";
import { sumBy } from "lodash";
import { flatten, chunk, fill } from "lodash";
import { date } from "yup";
import { isMobile } from 'react-device-detect';
import { TestCaseGroupChannel } from "../../report/test_case_group/Test-Case-Group-Channel";
import { TestRunResult } from "../TestRunResult";
import { RUN_TYPES } from "../../../helper/constants";
import digital_icon from "../../../images/digital_icon.svg";
import schedule_icon from "../../../images/schedule_icon.svg";
import fi_rs_phone_call from "../../../images/fi-rs-phone-call.svg";

const ContentDetails = ({
    classes,
    rates,
    caseGroup,
    groupName,
    checkedAll,
    checkedAllRates,
    handleChangeGroupRates,
    rate,
    value,
    setValue,
    selectedRates,
    handleSelectedRates,
    openGraph,
    setOpenGraph,
    chooseIndex,
    setChooseIndex,
    groupsLists,
    handleChange,
    handleChangeGroup,
    orderByGroup,
    handleCloseGraph,
    ExampleCustomInput,
    orderByCount,
    WARN,
    WARNCOLOR,
    FAIL,
    FAILCOLOR,
    showGraph,
    topbarVisible,
    runType,
    setRunType
}

) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleRunTypeChange = (event, newRunType) => {
        if (newRunType !== null) {
            setRunType(newRunType);
            reloadDashboardData(moment(value).format('YYYY-MM-DD'), newRunType)(dispatch);
        }
    };

    return (
        <div className={classes.container}>
            <Grid container spacing={isMobile ? 2 : 0}>
            <Grid item xs={12}>
                            <Typography variant="subtitle1">
                                <div style={{ fontSize: 14, marginTop: isMobile ? 16 : 0 }}>&nbsp; {t("runType")}</div>
                            </Typography>
                            <ToggleButtonGroup
                                value={runType}
                                exclusive
                                onChange={handleRunTypeChange}
                                sx={{
                                    '& .MuiToggleButton-root': {
                                        border: '1px solid var(--Tk-1, #006A68)',
                                        color: 'var(--Tk-1, #006A68)',
                                        '&.Mui-selected': {
                                            backgroundColor: 'var(--Tk3, #CCE8E6)',
                                            color: 'var(--Tk-1, #006A68)',
                                        },
                                        '&:hover': {
                                            backgroundColor: 'var(--Tk3, #CCE8E6)',
                                        },
                                    },
                                }}
                            >
                                <ToggleButton value={RUN_TYPES.MANUAL}>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                        <img src={digital_icon} alt="" style={{width: '20px', height: '20px'}}/>
                                        <span>{t(RUN_TYPES.MANUAL)}</span>
                                    </div>
                                </ToggleButton>
                                <ToggleButton value={RUN_TYPES.SCHEDULE}>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                        <img src={schedule_icon} alt="" style={{width: '20px', height: '20px'}}/>
                                        <span>{t(RUN_TYPES.SCHEDULE)}</span>
                                    </div>
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                <Grid item xs={isMobile ? 12: 4}>
                {!topbarVisible && (
                    <Grid container className={classes.toolbar}>
                        <Grid item xs={12}>
                            <Typography variant="subtitle1">
                                <div style={{ fontSize: 14, marginTop: isMobile ? 16 : 0 }}>{t("selectTestCaseGroups")}</div>
                            </Typography>
                            <FormControl sx={{ m: 1, ml: 0, width: isMobile ? '100%' : '80%' }} size="small">
                                <InputLabel id="demo-multiple-chip-label"></InputLabel>
                                <Select
                                    labelId="demo-multiple-chip-label"
                                    id="demo-multiple-chip"
                                    multiple
                                    value={groupName}
                                    onChange={handleChange}
                                    input={<OutlinedInput id="select-multiple-chip" />}
                                    renderValue={(selected) => `${selected.length} of ${groupsLists?.data?.length} ${t("selected")}`}
                                    style={{ fontSize: 14 }}
                                >
                                    <MenuItem value="select all">
                                        <Checkbox checked={checkedAll}
                                            onChange={handleChangeGroup}
                                            style={{ transform: "scale(.75)" }}
                                            sx={{
                                                color: "#1f9997",
                                                "&.Mui-checked": {
                                                    color: "#1f9997",
                                                },
                                            }}
                                        />
                                        <ListItemText primary={t("selectAll")} />
                                    </MenuItem>

                                    {groupsLists ? groupsLists?.data?.map(({ name, channel }, index) => (
                                        <MenuItem key={index} value={name}>
                                            <Checkbox checked={groupName.indexOf(name) > -1}
                                                style={{ transform: "scale(.75)" }}
                                                sx={{
                                                    color: "#1f9997",
                                                    "&.Mui-checked": {
                                                        color: "#1f9997",
                                                    },
                                                }}
                                            />
                                            <ListItemText>
                                                <div style={{ fontSize: 14 }}><TestCaseGroupChannel group={{ channel }} />  {name}</div>
                                            </ListItemText>
                                        </MenuItem>
                                    )) : null}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="subtitle1">
                                <div style={{ fontSize: 14, marginTop: isMobile ? 16 : 0 }}>&nbsp; {t("filterBy")}</div>
                            </Typography>
                            <FormControl sx={{ m: 1, ml: 0, width: isMobile ? '100%' : '80%' }} size="small" >
                                <Select
                                    labelId="demo-select-small"
                                    id="demo-select-small"
                                    value={selectedRates}
                                    onChange={handleSelectedRates}
                                    multiple
                                    renderValue={(selected) => `${selected.length} of ${rates?.length} ${t("selected")}`}
                                    MenuProps={{
                                        disableScrollLock: true,
                                    }}
                                    style={{ fontSize: 14 }}
                                >

                                    <MenuItem>
                                        <Checkbox checked={checkedAllRates}
                                            onChange={handleChangeGroupRates}
                                            style={{ transform: "scale(.75)" }}
                                            sx={{
                                                color: "#1f9997",
                                                "&.Mui-checked": {
                                                    color: "#1f9997",
                                                },
                                            }}
                                        />
                                        <ListItemText primary={t("selectAll")} />
                                    </MenuItem>

                                    {rates ? rates?.map((name, index) => (
                                        <MenuItem key={name} value={index}>
                                            <Checkbox checked={selectedRates.indexOf(index) > -1}
                                                style={{ transform: "scale(.75)" }}
                                                sx={{
                                                    color: "#1f9997",
                                                    "&.Mui-checked": {
                                                        color: "#1f9997",
                                                    },
                                                }}
                                            />
                                            <ListItemText>
                                                {index == 0 ? t("rateTypes.0") : (index == 1 ? t("rateTypes.1") : (index == 2 ? t("rateTypes.2") : ''))}
                                            </ListItemText>
                                        </MenuItem>
                                    )) : null}
                                </Select>
                            </FormControl>
                        </Grid>

                        

                        <Grid item className={classes.flex} xs={12}>
                            <div className={isMobile ? "w-full" : "w-80"}>
                                <DatePicker
                                    selected={value}
                                    onChange={(date) => setValue(date)}
                                    customInput={<ExampleCustomInput />}
                                />
                            </div>

                        </Grid>

                    </Grid>
                )}
                    
                </Grid>
                <Grid item xs={isMobile ? 12 : 8} style={isMobile ? {paddingBottom: '10px'} : {}}>
                    <TestRunResult />
                </Grid>
            </Grid>

            <br />

            <TableContainer>
                <Table
                    style={isMobile ? { tableLayout: 'fixed', overflow: 'hidden' } : {}}
                    sx={{
                        [`& .${tableCellClasses.root}`]: {
                            border: "none",
                        },
                        minWidth: isMobile ? '100%' : 700
                    }} aria-label="spanning table"

                >
                    <TableHead>
                        <TableRow className={classes.tableHead}>
                            <TableCell align="left" colSpan={1}
                                onClick={orderByGroup}>
                                <span>{t("testCaseGroup.0")} <img src={sort} alt="pic" width="10px" /></span>
                            </TableCell>
                            {!isMobile ? (
                                <>
                                    <TableCell align="right" colSpan={1}
                                        onClick={()=>orderByCount(false)}>
                                        <span>{t("count")} <img src={sort} alt="pic" width="10px" /></span>
                                    </TableCell>
                                    <TableCell colSpan={1}>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </TableCell>
                                    <TableCell align="center" colSpan={3}>
                                        {t("chart")}
                                    </TableCell>
                                </>
                            ) : (
                                <TableCell align="right"
                                    onClick={()=>orderByCount(false)}>
                                    <span>{t("count")} <img src={sort} alt="pic" width="10px" /></span>
                                </TableCell>
                            )}

                        </TableRow>

                    </TableHead>
                    <TableBody>
                        {
                            caseGroup && (caseGroup || []).filter(c => groupName?.includes(c.name)).length > 0 ?
                                (caseGroup || []).filter(c => groupName?.includes(c.name)).map((value, index) =>
                                    <>
                                        <TableRow key={index} sx={{}}>
                                            <TableCell
                                                className={isMobile ? 'p-2' : ''}
                                                colSpan={2}
                                                sx={{
                                                    height: "120px",
                                                    width: isMobile ? 'auto' : '40%',
                                                }}
                                            >
                                                <Typography variant="subtitle1" style={{
                                                    borderRadius: "10px",
                                                    padding: "10px",
                                                    boxShadow: "0px 3px 6px #00000029",
                                                    fontFamily: "Montserrat",
                                                    display: isMobile ? "block" : "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    height: isMobile ? "60px" : "85px",
                                                    background: ' #FFFFFF 0% 0% no-repeat padding-box',
                                                }}>
                                                    <div
                                                        style={{ display: "flex", alignItems: "center" }}
                                                    >
                                                        {(selectedRates.length == 1) ? (rate === FAIL ? <CancelIcon
                                                            style={{ color: "red", fontSize: "28px" }} /> : rate === WARN ?

                                                            <WarningAmberIcon
                                                                style={{ color: WARNCOLOR, fontSize: "28px" }} /> :
                                                            <CheckCircleOutlineIcon
                                                                style={{ color: FAILCOLOR, fontSize: "28px" }} />) : null
                                                        }

                                                        &nbsp;
                                                        <span title={value.name} className={classes.truncate}
                                                            style={isMobile ? { width: '100%', fontSize: '12px' } : {}}>
                                                            <TestCaseGroupChannel group={groupsLists?.data?.find(g => +g.id === +value.id)} />{value.name}</span>
                                                    </div>

                                                    {(selectedRates.length == 1) ? (

                                                        <span style={{ fontFamily: "Montserrat", color: +rate === +FAIL ? "red" : +rate === +WARN ? WARNCOLOR : FAILCOLOR }}>
                                                            <b >{
                                                                !isNaN(value.countsPct[rate]) && Math.round(100 * value.countsPct[rate])
                                                            }%</b>
                                                            &nbsp;
                                                            ({value.counts[rate]}/{value.testRuns})</span>
                                                    ) :
                                                        <div style={{ display: 'flex', width: '100%', gap: '16px' }}>
                                                            {(selectedRates.indexOf(0) != -1) ? (
                                                                <div style={{ textAlign: 'center', paddingLeft: isMobile ? '10px' : '0', fontFamily: "Montserrat", color: FAILCOLOR, fontSize: isMobile ? "12px" : "18px", width: isMobile ? '30%' : '', display: isMobile ? 'flex' : 'block' }}>
                                                                    <CheckCircleOutlineIcon style={{ color: FAILCOLOR, fontSize: isMobile ? "18px" : "28px" }} />
                                                                    <br />
                                                                    <b >{
                                                                        !isNaN(value.countsPct[0]) && Math.round(100 * value.countsPct[0])
                                                                    }%</b>
                                                                    &nbsp;({value.counts[0]}/{value.testRuns})
                                                                </div>) : null}
                                                            {(selectedRates.indexOf(1) != -1) ? (
                                                                <div style={{ textAlign: 'center', fontFamily: "Montserrat", color: WARNCOLOR, fontSize: isMobile ? "12px" : "18px", width: isMobile ? '30%' : '', display: isMobile ? 'flex' : 'block' }}>
                                                                    <WarningAmberIcon style={{ color: WARNCOLOR, fontSize: isMobile ? "18px" : "28px" }} />
                                                                    <br />
                                                                    <b >{
                                                                        !isNaN(value.countsPct[1]) && Math.round(100 * value.countsPct[1])
                                                                    }%</b>
                                                                    &nbsp;({value.counts[1]}/{value.testRuns})
                                                                </div>) : null}
                                                            {(selectedRates.indexOf(2) != -1) ? (
                                                                <div style={{ textAlign: 'center', fontFamily: "Montserrat", color: "red", fontSize: isMobile ? "12px" : "18px", width: isMobile ? '30%' : '', display: isMobile ? 'flex' : 'block' }}>
                                                                    <CancelIcon style={{ color: "red", fontSize: isMobile ? "18px" : "28px" }} />
                                                                    <br />
                                                                    <b >{
                                                                        !isNaN(value.countsPct[2]) && Math.round(100 * value.countsPct[2])
                                                                    }%</b>
                                                                    &nbsp;({value.counts[2]}/{value.testRuns})
                                                                </div>) : null}
                                                        </div>
                                                    }

                                                </Typography>
                                            </TableCell>

                                            {!isMobile && (
                                                <>
                                                    <TableCell colSpan={1} />
                                                    <TableCell colSpan={3}
                                                        align="right"
                                                        sx={{
                                                            borderRadius: "20px",
                                                            height: "120px"
                                                        }}

                                                        onClick={() => showGraph(value)} style={{ cursor: "pointer", }}
                                                    >
                                                        <div id={`main_${value.id}`}
                                                            className={classes.graph}
                                                        >
                                                        </div>

                                                    </TableCell>
                                                </>
                                            )}
                                        </TableRow>
                                        {isMobile && (
                                            <TableRow>
                                                <TableCell colSpan={2}
                                                    className="p-2"
                                                    sx={{
                                                        borderRadius: "20px",
                                                        height: "120px"
                                                    }}
                                                    onClick={() => showGraph(value)} style={{ cursor: "pointer", }}>
                                                    <div id={`main_${value.id}`}
                                                        className={classes.graph}
                                                    >
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </>
                                ) :
                                <TableRow>
                                    <TableCell colSpan={5}
                                        sx={{
                                            borderRadius: "5px",
                                            border: "1px solid lightgrey",
                                            padding: "20px",
                                            boxShadow: "2px 2px lightgrey",
                                            fontFamily: "Montserrat",
                                            align: "center",
                                            fontSize: "20px"
                                        }}>
                                        No Data
                                    </TableCell>
                                </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            {
                caseGroup && chooseIndex ?
                    <Modal
                        open={openGraph}
                        onClose={handleCloseGraph}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box className={classes.largeGraph} style={{ outline: 0 }}>
                            <br />
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography id="modal-modal-title" variant="h6" component="h2">
                                    &nbsp;&nbsp;{chooseIndex.name} ({chooseIndex.testRuns})
                                    {(selectedRates.length == 1) && (
                                        <span
                                            style={{
                                                color:
                                                    rate === FAIL ? "red" : rate === WARN ? WARNCOLOR : FAILCOLOR
                                            }}>
                                            {chooseIndex.counts[rate]}&nbsp;({!isNaN(chooseIndex.countsPct[rate]) && Math.round(100 * chooseIndex.countsPct[rate])}%)
                                        </span>
                                    )}
                                </Typography>
                                <Typography style={{ cursor: "pointer" }}>
                                    <CancelIcon onClick={() => {
                                        setOpenGraph(false)
                                        setChooseIndex(null)
                                    }} />&nbsp;&nbsp;
                                </Typography>
                            </div>
                            <Typography id="main" style={{ width: isMobile ? '100vw' : "900px", height: "400px" }}
                            >
                            </Typography>
                        </Box>
                    </Modal> : null

            }

        </div>
    );
};

export default ContentDetails;
